import { useState, useEffect } from 'react';
import { useReduxToken } from '@Hooks/reduxTokenHook/useReduxToken';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';

function useThemeChange() {

    const { token } = useReduxToken();
    const { activeUserPreferencesAll } = useReduxActiveUser();

    // Correctly detect system dark mode preference
    const [isSystemDark, setIsSystemDark] = useState(
        () => window.matchMedia('(prefers-color-scheme: dark)').matches
    );

    // Keep in sync with OS-level changes
    useEffect(() => {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => setIsSystemDark(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    // Apply the resolved theme to <html data-theme="...">
    useEffect(() => {
        const targetHtml = document.querySelector('html');
        if (!targetHtml) return;

        const themePref = activeUserPreferencesAll?.theme;
        let theme;

        if (!token || token === 'void') {
            // Not logged in — follow system
            theme = isSystemDark ? 'dark' : 'light';
        } else if (!themePref || themePref === 'system') {
            // Logged in, preference is "system" or unset — follow OS
            theme = isSystemDark ? 'dark' : 'light';
        } else {
            // Explicit user choice: 'dark' or 'light'
            theme = themePref;
        }

        targetHtml.setAttribute('data-theme', theme);
    }, [token, isSystemDark, activeUserPreferencesAll?.theme]);
}

export default useThemeChange;
